export const PopUps = {
  CHECK_IN_POPUP: "Auftrag wieder Eingebucht",
  CHECK_OUT_POPUP: "Auftrag Ausgebucht",
  DELETE_DENTIST_POPUP: "Are you sure you want to delete this dentist?",
  DELETE_ORDER_POPUP: "Auftrag Löschen",
  DELETE_USER_POPUP: "Are you sure you want to delete this user?",
  DELETE_WORKFLOW_DEPARTMENT_POPUP:
    "Möchten Sie diese Zeile wirklich entfernen?",
  //   EDIT_DENTIST_DETAIL_POPUP: "",
  //   EDIT_DETAIL_POPUP: "",
  //   EDIT_STANDARD_NOTE_POPUP: "",
  //   FILE_UPLOAD_POPUP: "",
  FORGOT_POPUP:
    "Ein Link zum Zurücksetzen des Passworts wurde an Ihre registrierte E-Mail-Adresse gesendet.",
  ORDER_POPUP: "Der Auftrag wurde erfolgreich angelegt.",
  RESET_POPUP: "Ihre Pin wurde erfolgreich zurückgesetzt.",
  UPDATE_PIN_POPUP: "Ihre PIN wurde erfolgreich aktualisiert",
  //   UPLOAD_DENTIST_POPUP: "",
  //   UPLOAD_STANDARD_NOTES_POPUP: "",
  VERIFY_TOKEN_POPUP: "Ungültiger oder abgelaufener Reset-Token.",
  VIEW_SHEET_POPUP: "PDF wird generiert.",
  WORKFLOW_POPUP: "Der Auftrag wurde erfolgreich aktualisiert.",
};

export const ERROR_MESSAGES_LOGIN = {
  UID: "Der Benutzername muss aus 3 Großbuchstaben bestehen (z. B. XYZ).",
  PIN: "Die Pin muss genau 4 Ziffern haben.",
  UNEXPECTED: "Ein unerwarteter Fehler ist aufgetreten.",
};
export const ERROR_MESSAGES_FORGOT = {
  REQUIRED: "E-Mail ist erforderlich",
  FORMAT: "Ungültige E-Mail",
  UNEXPECTED: "Ein unerwarteter Fehler ist aufgetreten.",
};
export const ERROR_MESSAGES_RESET = {
  REQUIRED_PIN: "Die Pin muss genau 4 Ziffern haben.",
  REQUIRED_CPIN: "Die PIN muss genau 4 Ziffern lang sein.",
  UNEXPECTED: "Ein unerwarteter Fehler ist aufgetreten.",
};
